import type { MailboxInfo } from "owa-client-types";
import { getApplicationSettings } from "owa-application-settings";
import { isOfflinePeopleDataViaPDVEnabled } from "./isOfflinePeopleDataViaPDVEnabled";
import { isAccountFeatureEnabled } from "owa-feature-flags";
import { getGlobalSettingsAccountMailboxInfo } from "owa-account-source-list-store";

export const isPersonSourcesEnabled = (mailboxInfo: MailboxInfo): boolean => {
    // For OWA, we don't have PDV support yet, so for now we only check if one-person-view flight is enabled
    return ((getApplicationSettings("OnePersonView").enabled &&
        getApplicationSettings("Jana").lpeNova &&
        isOfflinePeopleDataViaPDVEnabled(mailboxInfo)) ||
        isAccountFeatureEnabled("peo-one-person-view", getGlobalSettingsAccountMailboxInfo()));
};
